export class ArgumentError extends Error
{
    /** Gets the name of the parameter that caused the error. */
    public readonly paramName: string;

    /** Gets the name of the parameter that caused the error. */
    public readonly paramValue: any;

    /**
     * Creates a new ArgumentError object to indicate that an invalid argument was provided to a method.
     * @param message Explanatory error message.
     * @param paramName Name of the parameter that caused the error.
     */
    constructor(message?: string, paramName?: string, paramValue?: any)
    {
        super(message);
        Object.setPrototypeOf(this, ArgumentError.prototype); // Extending native object.
        this.name = "ArgumentError";
        this.stack = (new Error()).stack;

        this.paramName = paramName || "";
        this.paramValue = paramValue;

        if (message)
        {
            this.message = `'${paramName}' was given an invalid value '${paramValue}'. ${message}`;
        }
        else
        {
            this.message = `'${paramName}' was given an invalid value '${paramValue}'.`;
        }
    }
}
